import { useSelector } from 'react-redux';

import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../../redux-helpers/types';
import { workspaceByIdSelector } from '../../redux-utils/selectors';

/**
 * Custom hook to get workspace organisation by workspace / organisation ID
 * @param workspaceId - The ID of the workspace
 * @param organisationId - The ID of the organisation
 */
export const useWorkspaceOrganisationSelector = (workspaceId: string, organisationId: string) => {
  return useSelector((store: StoreState) => {
    const { normalised } = store;
    const workspace = workspaceByIdSelector(normalised, workspaceId) as WorkspacesListingItem | null;
    const organisation = workspace && workspace.organisations?.find(org => org.id === organisationId);
    return organisation || null;
  });
};
